// extracted by mini-css-extract-plugin
export default {"alert_box":"Alert_alert_box__a962b","alert__icon":"Alert_alert__icon__gPpdY","alert__description":"Alert_alert__description__K7YdI"};